import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaStar } from "react-icons/fa";
import { useSwipeable } from "react-swipeable";

import client1 from "../../assets/testimonial1.jpeg"; 
import client2 from "../../assets/testimonial2.jpeg";
import client3 from "../../assets/testimonial3.jpeg";

const testimonials = [
  {
    name: "Parent of a 15-year-old",
    role: "Parent",
    image: client1,
    rating: 5,
    feedback:
      "The sessions at Butterfly Wellness Clinic helped my daughter open up in ways I never thought possible. She feels heard and understood, and we’ve seen such a positive change in her confidence and outlook.",
  },
  {
    name: "Couple in Therapy",
    role: "Couple",
    image: client2,
    rating: 4,
    feedback:
      "Therapy sessions helped us improve communication and strengthen our relationship. We feel more connected and supported.",
  },
  {
    name: "Working Professional",
    role: "Professional",
    image: client3,
    rating: 5,
    feedback:
      "Therapy sessions helped me manage stress and anxiety effectively. I feel calmer, more focused, and confident in handling challenges at work.",
  },
];

const WelnessTestimonials = () => {
  const [current, setCurrent] = useState(0);

  const leftIndex = current === 0 ? testimonials.length - 1 : current - 1;
  const rightIndex = (current + 1) % testimonials.length;

  // Swipe handlers
  const handlers = useSwipeable({
    onSwipedLeft: () => setCurrent((prev) => (prev + 1) % testimonials.length),
    onSwipedRight: () => setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1)),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div data-aos="fade-in" className="my-10 px-4 md:px-0">
      <h2 className="text-2xl md:text-3xl text-center font-bold mb-8 md:mb-12 text-gray-900">
        WHAT OUR CLIENTS SAY
      </h2>

      <div {...handlers} className="relative w-full overflow-hidden">
        <div className="flex items-center justify-center md:justify-start space-x-0 md:space-x-6">

          {/* Left Preview */}
          <div
            onClick={() => setCurrent(leftIndex)}
            className="hidden md:block w-1/4 transform -translate-x-1/4 opacity-60 scale-90 hover:scale-105 cursor-pointer transition"
          >
            <div className="bg-[#2A77B7] text-white rounded-3xl p-4 md:p-6 flex items-center space-x-3 md:space-x-4 shadow-lg">
              <img
                src={testimonials[leftIndex].image}
                alt={testimonials[leftIndex].name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-white shadow"
              />
              <div>
                <div className="flex mb-1">
                  {[...Array(testimonials[leftIndex].rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-xs md:text-sm" />
                  ))}
                </div>
                <p className="text-xs md:text-sm italic line-clamp-2">
                  "{testimonials[leftIndex].feedback}"
                </p>
                <h3 className="mt-1 font-semibold text-xs md:text-sm">{testimonials[leftIndex].name}</h3>
                <p className="text-[10px] md:text-xs opacity-70">{testimonials[leftIndex].role}</p>
              </div>
            </div>
          </div>

          {/* Center Full */}
          <div className="w-full md:w-1/2 z-10 transition scale-100 md:scale-120">
            <div className="bg-[#2A77B7] text-white rounded-3xl p-6 md:p-8 flex flex-col md:flex-row items-center md:space-x-6 shadow-xl">
              <img
                src={testimonials[current].image}
                alt={testimonials[current].name}
                className="w-24 h-24 md:w-28 md:h-28 rounded-full border-2 border-white shadow-md mb-4 md:mb-0"
              />
              <div className="text-center md:text-left">
                <div className="flex justify-center md:justify-start mb-2">
                  {[...Array(testimonials[current].rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-sm md:text-base" />
                  ))}
                </div>
                <p className="italic text-sm md:text-base leading-relaxed">
                  "{testimonials[current].feedback}"
                </p>
                <h3 className="mt-4 font-semibold text-base md:text-lg">{testimonials[current].name}</h3>
                <p className="text-sm opacity-80">{testimonials[current].role}</p>
              </div>
            </div>
          </div>

          {/* Right Preview */}
          <div
            onClick={() => setCurrent(rightIndex)}
            className="hidden md:block w-1/4 transform translate-x-1/4 opacity-60 scale-90 hover:scale-105 cursor-pointer transition"
          >
            <div className="bg-[#2A77B7] text-white rounded-3xl p-4 md:p-6 flex items-center space-x-3 md:space-x-4 shadow-lg">
              <img
                src={testimonials[rightIndex].image}
                alt={testimonials[rightIndex].name}
                className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-white shadow"
              />
              <div>
                <div className="flex mb-1">
                  {[...Array(testimonials[rightIndex].rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-xs md:text-sm" />
                  ))}
                </div>
                <p className="text-xs md:text-sm italic line-clamp-2">
                  "{testimonials[rightIndex].feedback}"
                </p>
                <h3 className="mt-1 font-semibold text-xs md:text-sm">{testimonials[rightIndex].name}</h3>
                <p className="text-[10px] md:text-xs opacity-70">{testimonials[rightIndex].role}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WelnessTestimonials;
